import { useEffect, useCallback } from 'react';
import { useComposeBoxContext } from '../composeBoxContext';

const DROPBOX_EVENT = 'attach-dropbox-files';

export const useDropbox = () => {
  const { uploadUrlsToCompose } = useComposeBoxContext();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const expectedOrigin = `https://${WEBPACK_APP}`;

      if (event.origin !== expectedOrigin) {
        return;
      }

      if (event.data?.event === DROPBOX_EVENT && event.data?.mediaLinkData.length) {
        uploadUrlsToCompose(event.data.mediaLinkData);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [uploadUrlsToCompose]);

  const openDropbox = useCallback(() => {
    window.open(`https://${WEBPACK_APP}/dropbox.html?allowVideosPdfs=true`, '_blank');
  }, []);

  return { openDropbox };
};
